export default "__VITE_ASSET__COkSc785__"